// France
export const locale = {
  "1": "{attribute} باید پذیرفته شده باشد.",
  "2": "آدرس {attribute} معتبر نیست.",
  "3": "{attribute} باید تاریخی بعد از {date} باشد.",
  "4": "{attribute} باید تاریخی بعد از {date}، یا مطابق با آن باشد.",
  "5": "{attribute} باید فقط حروف الفبا باشد.",
  "6": "{attribute} باید فقط حروف الفبا، اعداد، خط تیره و زیرخط باشد.",
  "7": "{attribute} باید فقط حروف الفبا و اعداد باشد.",
  "8": "{attribute} باید آرایه باشد.",
  "9": "{attribute} باید تاریخی قبل از {date} باشد.",
  "10": "{attribute} باید تاریخی قبل از {date}، یا مطابق با آن باشد.",
  "11": "{attribute} باید بین {min} و {max} باشد.",
  "12": "{attribute} باید بین {min} و {max} کیلوبایت باشد.",
  "13": "{attribute} باید بین {min} و {max} کاراکتر باشد.",
  "14": "{attribute} باید بین {min} و {max} آیتم باشد.",
  "15": "فیلد {attribute} فقط می‌تواند true و یا false باشد.",
  "16": "{attribute} با فیلد تکرار مطابقت ندارد.",
  "17": "{attribute} یک تاریخ معتبر نیست.",
  "18": "{attribute} باید یک تاریخ برابر با تاریخ {date} باشد.",
  "19": "{attribute} با الگوی {format} مطابقت ندارد.",
  "20": "{attribute} و {other} باید از یکدیگر متفاوت باشند.",
  "21": "{attribute} باید {digits} رقم باشد.",
  "22": "{attribute} باید بین {min} و {max} رقم باشد.",
  "23": "ابعاد تصویر {attribute} قابل قبول نیست.",
  "24": "فیلد {attribute} مقدار تکراری دارد.",
  "25": "{attribute} باید یک ایمیل معتبر باشد.",
  "26": "فیلد {attribute} باید با یکی از مقادیر زیر خاتمه یابد: {values}",
  "27": "{attribute} انتخاب شده، معتبر نیست.",
  "28": "{attribute} باید یک فایل معتبر باشد.",
  "29": "فیلد {attribute} باید مقدار داشته باشد.",
  "30": "{attribute} باید بزرگتر از {value} باشد.",
  "31": "{attribute} باید بزرگتر از {value} کیلوبایت باشد.",
  "32": "{attribute} باید بیشتر از {value} کاراکتر داشته باشد.",
  "33": "{attribute} باید بیشتر از {value} آیتم داشته باشد.",
  "34": "{attribute} باید بزرگتر یا مساوی {value} باشد.",
  "35": "{attribute} باید بزرگتر یا مساوی {value} کیلوبایت باشد.",
  "36": "{attribute} باید بیشتر یا مساوی {value} کاراکتر داشته باشد.",
  "37": "{attribute} باید بیشتر یا مساوی {value} آیتم داشته باشد.",
  "38": "{attribute} باید یک تصویر معتبر باشد.",
  "39": "{attribute} انتخاب شده، معتبر نیست.",
  "40": "فیلد {attribute} در لیست {other} وجود ندارد.",
  "41": "{attribute} باید عدد صحیح باشد.",
  "42": "{attribute} باید آدرس IP معتبر باشد.",
  "43": "{attribute} باید یک آدرس معتبر از نوع IPv4 باشد.",
  "44": "{attribute} باید یک آدرس معتبر از نوع IPv6 باشد.",
  "45": "فیلد {attribute} باید یک رشته از نوع JSON باشد.",
  "46": "{attribute} باید کوچکتر از {value} باشد.",
  "47": "{attribute} باید کوچکتر از {value} کیلوبایت باشد.",
  "48": "{attribute} باید کمتر از {value} کاراکتر داشته باشد.",
  "49": "{attribute} باید کمتر از {value} آیتم داشته باشد.",
  "50": "{attribute} باید کوچکتر یا مساوی {value} باشد.",
  "51": "{attribute} باید کوچکتر یا مساوی {value} کیلوبایت باشد.",
  "52": "{attribute} باید کمتر یا مساوی {value} کاراکتر داشته باشد.",
  "53": "{attribute} باید کمتر یا مساوی {value} آیتم داشته باشد.",
  "54": "{attribute} نباید بزرگتر از {max} باشد.",
  "55": "{attribute} نباید بزرگتر از {max} کیلوبایت باشد.",
  "56": "{attribute} نباید بیشتر از {max} کاراکتر داشته باشد.",
  "57": "{attribute} نباید بیشتر از {max} آیتم داشته باشد.",
  "58": "فرمت‌های معتبر فایل عبارتند از: {values}.",
  "59": "فرمت‌های معتبر فایل عبارتند از: {values}.",
  "60": "{attribute} نباید کوچکتر از {min} باشد.",
  "61": "{attribute} نباید کوچکتر از {min} کیلوبایت باشد.",
  "62": "{attribute} نباید کمتر از {min} کاراکتر داشته باشد.",
  "63": "{attribute} نباید کمتر از {min} آیتم داشته باشد.",
  "64": "{attribute} انتخاب شده، معتبر نیست.",
  "65": "فرمت {attribute} معتبر نیست.",
  "66": "{attribute} باید عدد یا رشته‌ای از اعداد باشد.",
  "67": "The password is incorrect.",
  "68": "فیلد {attribute} باید در پارامترهای ارسالی وجود داشته باشد.",
  "69": "فرمت {attribute} معتبر نیست.",
  "70": "فیلد {attribute} الزامی است.",
  "71": "هنگامی که {other} برابر با {value} است، فیلد {attribute} الزامی است.",
  "72": "فیلد {attribute} الزامی است، مگر آنکه {other} در {values} موجود باشد.",
  "73": "در صورت وجود فیلد {values}، فیلد {attribute} نیز الزامی است.",
  "74": "در صورت وجود فیلدهای {values}، فیلد {attribute} نیز الزامی است.",
  "75": "در صورت عدم وجود فیلد {values}، فیلد {attribute} الزامی است.",
  "76": "در صورت عدم وجود هر یک از فیلدهای {values}، فیلد {attribute} الزامی است.",
  "77": "{attribute} و {other} باید همانند هم باشند.",
  "78": "{attribute} باید برابر با {size} باشد.",
  "79": "{attribute} باید برابر با {size} کیلوبایت باشد.",
  "80": "{attribute} باید برابر با {size} کاراکتر باشد.",
  "81": "{attribute} باید شامل {size} آیتم باشد.",
  "82": "{attribute} باید با یکی از این ها شروع شود: {values}",
  "83": "فیلد {attribute} باید متن باشد.",
  "84": "فیلد {attribute} باید یک منطقه زمانی معتبر باشد.",
  "85": "{attribute} قبلا انتخاب شده است.",
  "86": "بارگذاری فایل {attribute} موفقیت آمیز نبود.",
  "87": "{attribute} معتبر نمی‌باشد.",
  "88": "{attribute} باید یک UUID معتبر باشد.",
  "89": "{attribute} باید زمانی در آینده باشد.",
  "90": "فقط کلمات فارسی باید وارد شود.",
  "91": "نام کاربری فقط شامل حروف انگلیسی و عدد میباشد.",
  "92": "فرمت کد ملی درست نمیباشد .",
  "93": "فرمت شماره موبایل اشتباه میباشد.",
  "94": "فرمت شماره موبایل اشتباه میباشد.",
  
  "1005": "داده‌های ورودی معتبر نیستند.",
  "60001" : "اطلاعات تکمیل نشده است.",
  "60007" : "این نوع دارای بیلبورد میباشد و قابل حذف نیست.",


  "attributes":{
    "name": "\u0646\u0627\u0645",
    "lastName": "\u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc",
    "username": "\u0646\u0627\u0645 \u06a9\u0627\u0631\u0628\u0631\u06cc",
    "email": "\u067e\u0633\u062a \u0627\u0644\u06a9\u062a\u0631\u0648\u0646\u06cc\u06a9\u06cc",
    "first_name": "\u0646\u0627\u0645",
    "last_name": "\u0646\u0627\u0645 \u062e\u0627\u0646\u0648\u0627\u062f\u06af\u06cc",
    "password": "\u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "password_confirmation": "\u062a\u0627\u06cc\u06cc\u062f\u06cc\u0647 \u06cc \u0631\u0645\u0632 \u0639\u0628\u0648\u0631",
    "city": "\u0634\u0647\u0631",
    "country": "\u06a9\u0634\u0648\u0631",
    "address": "\u0646\u0634\u0627\u0646\u06cc",
    "phone": "\u062a\u0644\u0641\u0646",
    "mobile": "\u062a\u0644\u0641\u0646 \u0647\u0645\u0631\u0627\u0647",
    "age": "\u0633\u0646",
    "sex": "\u062c\u0646\u0633\u06cc\u062a",
    "gender": "\u062c\u0646\u0633\u06cc\u062a",
    "day": "\u0631\u0648\u0632",
    "month": "\u0645\u0627\u0647",
    "year": "\u0633\u0627\u0644",
    "hour": "\u0633\u0627\u0639\u062a",
    "minute": "\u062f\u0642\u06cc\u0642\u0647",
    "second": "\u062b\u0627\u0646\u06cc\u0647",
    "title": "\u0639\u0646\u0648\u0627\u0646",
    "text": "\u0645\u062a\u0646",
    "content": "\u0645\u062d\u062a\u0648\u0627",
    "description": "\u062a\u0648\u0636\u06cc\u062d\u0627\u062a",
    "excerpt": "\u06af\u0644\u0686\u06cc\u0646 \u06a9\u0631\u062f\u0646",
    "date": "\u062a\u0627\u0631\u06cc\u062e",
    "time": "\u0632\u0645\u0627\u0646",
    "available": "\u0645\u0648\u062c\u0648\u062f",
    "size": "\u0627\u0646\u062f\u0627\u0632\u0647",
    "type": "\u0646\u0648\u0639",
    "contact": "\u06a9\u0627\u0646\u062a\u06a9\u062a"
  },



  GLOBAL :{
    Title : "پیامک لند",
    PostalCode : "کد پستی",
    postalCodes : "کد های پستی",
    selectedPostalCodes : "کد های پستی انتخاب شده",
    MciNumberCount : "تعداد همراه اول",
    MtuNumberCount : "تعداد ایرانسل",
    TotalCount : "تعداد کل",
    Coefficient : "ضریب",
    Back : "بازگشت"
  },
  ERRORS:{
    PhoneIsNotValid : "شماره تلفن وارد شده صحیح نمیباشد: نمونه 09101234567",
    InvalidNumber : "تعداد وارد شده صحیح نمیباشد",
    NoSelectedLineNumber : "خط ارسالی را انتخاب کنید.",
    EmptyText : "لطفا متن را وارد کنید.",
    UnknownError : "خطای نامشخص",
    TryAgain : "لطفا کمی بعد دباره تلاش کنید.",
    NoAccountCharge : "موجودی ناکافی",
    NoAccess : "دسترسی ندارید.",
    PleasebyeAPlane : "لطفا یک پلن خریداری کنید.",
    PleaseChargeYourAccount : "لطفا اکانت خود را شارژ کنید.",
    AccessDenied: "دسترسی ندارید.",
    AccessDeniedDescription : "برای اطلاعات بیشتر با پشتیبانی تماس بگیرید",
    Error : "خطا",
    InvalidText : "متن نامعتبر",
    InvalidTextContainsLink : "تنها خطوط خدماتی میتوانند حاوی لینک باشند."
  },
  INFOS : {
    SuccessSentSms : "پیام ارسال شد",
    SmsRequestInQueue : "پیام شما بعد از تایید مدیر ارسال خواهد شد",
    SendData : "اطلاعات ارسال",
    CheckData : "اطلاعات زیر را بخوانید و تایید کنید."
  },
  TOBE:{
    to:"به ",
    from:"از ",
  },
  FORMS:{
    DestinationPhone : "شماره تلفن گیرنده",
    TestDestinationPhone : "شماره تلفن تست",
    SourceNumber : "شماره فرستده",
    Text : "متن",
    CharCount : "تعداد کاراکترها",
    FarsiCharCount: "تعداد کاراکترهای فارسی",
    EnglishCharCount : "تعداد کاراکتر های انگلیسی",
    Send : "ارسال",
    SendTime : "زمان ارسال",
    SendTest : "ارسال تستی",
    SendToTestNumber : "ارسال به شماره تست",
    SmsCount : "تعداد پیامک",
    SmsLang : "زبان پیامک",
    Add:"اضافه کردن",
    FromFile : "افزودن فایل",
    TestNumber: "شماره تست",
    Test : "تست",
    ServiceRelated : "خدماتی",
    Price : "قیمت",
    NumbersCount : "تعداد شماره ها",
    NumbersCountToSend : "تعدا شماره هایی که به آنها پیام ارسال میشود",
    Search : "جستجو",
    Title : "عنوان",
    RequestTime : "زمان درخواست",
    RequestInformation : "اطلاعات درخواست" ,
    CreateNewPhoneBook: "ساخت دفترچه تلفن جدید"
  },
  BUTTONS:{
    OK : "باشه",
    AccountCharge : "شارژ حساب",
    Reports: "گزارش ها",
    RemoveAll : "حذف همه",
    BuyAPlane: "خرید پلن",
    Accept : "تایید",
    Reject : "رد کردن",
    Yes : "بله",
    No : "خیر",
    Create : "ایجاد",
    New : "جدید",
    Save : "ذخیره",
    Delete:"حذف",
    More : "بیشتر",
    TryAgain : "تلاش مجدد",
    Close : "بستن"
  },
  DIALOGS:{
    Waiting: "لطفا صبر کنید",
    RejectItQuestion: "رد شود؟",
    AcceptItQuestion: "تایید شود؟",
    Rejected: "رد شد",
    Accepted: "تایید شد",
    Error: "خطا",
  },
  CONFIRM:{
    Delete : "آیا از حذف مطمعین هستید؟",
    DeleteA : "ایا مطمعین از حذف {a} هستید",
    DeleteALL : "آیا از حذف همه مطمعین هستید؟"
  },
  LANGUAGE:{
    English : "انگلیسی",
    Persian : "فارسی"
  },
  LISTS: {
    NoData : "داده ای وجود ندارد",
    NoDataFound : "داده ای پیدا نشد",
    NoDataFoundFor : "داده ای برای {a} پیدا نشد",
    NoPhoneNumber : "شماره ای پیدا نشد",
    NoPostalCode : "کد پستی ای پیدا نشد",
    AddANumber : "شماره ای اضافه کنید",
    City : "شهر",
    AddedBefore : "قبلا اضافه شده است"
  },
  PAGES: {
    SendSms : "ارسال پیامک",
    MapSms : "ارسال با نقشه",
    PhoneBook : "دفترچه تلفن",
  },
  MONETARY :{
    Rial : "ریال"
  },
  HINTS:{
    SendMessageTitle : "عنوان نام دلخواهی است که میتوانید از عنوان پیام های قبلی ارسال شده استفاده کنید تا متن پیام در بخش متن نوشته شود. عنوان در پیام ارسال نمیشود. عنوان برای بخش گذارش گیری و پیشنهادات پیام استفاده میشود.",
    SendMessageTime : "زمان ارسال زمانی است که پیامک شما در صف ارسال قرار گرفته میشود. ت.جه داشته باشید که در صورت تایید نشدن توسط ادمین پیامک ارسال نمیشود.",
    CreatePhoneBook : "هنگام ارسال پیامک برای اضافه کردن شماره ازا این نام استفاده میشود."
  },
  TOASTS :{
    SuccessCreate : "با موقیت ایجاد شد",
    FailedCreated : "خطا در ایجاد کردن",
    SuccessDelete : "حذف شد",
    FailedDelete : "خطا در حذف",
    SuccessEdit : "ویرایش شد",
    FailedEdit : "خطا در ویرایش",
    AddedSuccess: "اضافه شد",
    AddedFailed: "خطا در اضافه کردن"
  },

  WALLET:{
    CustomCharge : "مبلغ دلخواه",
    GateWay : "درگاه پرداخت",
    Price : "مبلغ",
    Details : [
      "٩٪؜ ماليات به مبلغ وارد شده اضافه خواهد شد.",
      "لطفا در درج مبلغ دقت لازم را مبذول فرمایید، مبلغ واریزی به هیچ عنوان قابل استرداد نمی باشد."
    ],
    noGateWay : "درگاهی برای شما تعریف نشده است.",
    PriceNotInRange : "مبلغ ورودی باید بین {min} ریال و {max} ریال باشد.",
    Pay : "پرداخت",
    ErrorOnRedirectToGateWay : "خطا در انتقال به درگاه پرداخت",
    ChargeWalletButtonDescription : "بازدن روی دکمه + حساب خود را شارژ کنید",
  },

  TRANSLATOR: {
    SELECT: "choisissez votre langue"
  },
  MENU: {
    NEW: "Nouveau",
    ACTIONS: "Actes",
    CREATE_POST: "Créer un nouveau Post",
    PAGES: "Pages",
    FEATURES: "Fonctionnalités",
    APPS: "Applications",
    DASHBOARD: "Tableau de Bord"
  },
  AUTH: {
    GENERAL: {
      OR: "Ou",
      SUBMIT_BUTTON: "Soumettre",
      NO_ACCOUNT: "Ne pas avoir de compte?",
      SIGNUP_BUTTON: "Registre",
      FORGOT_BUTTON: "Mot de passe oublié",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Créer un compte",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Mot de passe",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Nom d'utilisateur"
    },
    VALIDATION: {
      INVALID: "{{name}} n'est pas valide",
      REQUIRED: "{{name}} est requis",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    ECOMMERCE: "éCommerce",
    CUSTOMERS: {
      CUSTOMERS: "Les clients",
      CUSTOMERS_LIST: "Liste des clients",
      NEW_CUSTOMER: "Nouveau client",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Suppression du client",
        DESCRIPTION: "Êtes-vous sûr de supprimer définitivement ce client?",
        WAIT_DESCRIPTION: "Le client est en train de supprimer ...",
        MESSAGE: "Le client a été supprimé"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Supprimer les clients",
        DESCRIPTION:
            "Êtes-vous sûr de supprimer définitivement les clients sélectionnés?",
        WAIT_DESCRIPTION: "Les clients suppriment ...",
        MESSAGE: "Les clients sélectionnés ont été supprimés"
      },
      UPDATE_STATUS: {
        TITLE: "Le statut a été mis à jour pour les clients sélectionnés",
        MESSAGE:
            "Le statut des clients sélectionnés a été mis à jour avec succès"
      },
      EDIT: {
        UPDATE_MESSAGE: "Le client a été mis à jour",
        ADD_MESSAGE: "Le client a été créé"
      }
    }
  }
};
